import React, { useCallback } from 'react';
import { ActionButton, ShellBar } from '@sba/design-system';
import useVersionLabelText from '../composer/hooks/useVersionLabelText';
import styles from '../composer/layout/ShellBar.module.css';
import useUserDisplayName from '../composer/hooks/useUserDisplayName';
import useSignoutUrl from '../composer/hooks/useSignoutUrl';
import useUserNameInitials from '../composer/hooks/useUserNameInitials';
import useSurveyUrl from '../composer/hooks/useSurveyUrl';
import usePrivacyStatementUrl from '../composer/hooks/usePrivacyStatementUrl';

export default function ComposerShellBar() {
  const userDisplayName = useUserDisplayName();
  const userInitials = useUserNameInitials();
  const signoutUrl = useSignoutUrl();
  const versionLabelText = useVersionLabelText();

  const onSignOut = useCallback(() => {
    window.location.href = signoutUrl;
  }, [signoutUrl]);
  const surveyUrl = useSurveyUrl();
  const privacyStatementUrl = usePrivacyStatementUrl();
  const openFeedbackSurvey = useCallback(() => {
    if (surveyUrl) {
      window.open(surveyUrl);
    }
  }, [surveyUrl]);

  return (
    <ShellBar
      href={window.location.origin}
      userDisplayName={userDisplayName ?? 'No name'}
      mainTitle="App Editor"
      onSignOut={onSignOut}
      className={styles.sbaShellBar}
      actionButtons={<ActionButton onClick={openFeedbackSurvey} iconName="feedback" aria-label="Feedback" />}
      avatar={userInitials}
      versionLabelText={versionLabelText}
      privacyStatementUrl={privacyStatementUrl}
    />
  );
}
